<template>
  <div>
    <input
      type="text"
      :value="displayValue"
      :placeholder="placeholder"
      readonly
      @click="openDialog"
      class="area-picker-input"
    >
    <van-popup v-model="showDialog" position="bottom" :close-on-click-overlay="false">
      <div class="area-dialog-wrap">
        <div class="area-dialog-title">请选择省市区</div>
        <div class="area-dialog-selects">
          <select v-model="selectedProvinceId" @change="onProvinceChange" class="area-select">
            <option value="">请选择省</option>
            <option v-for="p in provinceList" :key="p.id" :value="p.id">{{ p.sys_name }}</option>
          </select>
          <select v-if="cityList.length" v-model="selectedCityId" @change="onCityChange" class="area-select">
            <option value="">请选择市</option>
            <option v-for="c in cityList" :key="c.id" :value="c.id">{{ c.sys_name }}</option>
          </select>
          <select v-if="areaList2.length" v-model="selectedAreaId" @change="onAreaChange" class="area-select">
            <option value="">请选择区</option>
            <option v-for="a in areaList2" :key="a.id" :value="a.id">{{ a.sys_name }}</option>
          </select>
        </div>
        <div class="area-dialog-btns">
          <button class="area-btn cancel" @click="cancel">取消</button>
          <button class="area-btn confirm" @click="confirm">确定</button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'AreaPicker',
  props: {
    value: {
      type: Object,
      default: () => ({ provice_id: '', city_id: '', area_id: '', provice_name: '', city_name: '', area_name: '' })
    },
    placeholder: {
      type: String,
      default: '请选择省市区'
    }
  },
  data() {
    return {
      showDialog: false,
      provinceList: [],
      cityList: [],
      areaList2: [],
      selectedProvinceId: '',
      selectedCityId: '',
      selectedAreaId: '',
      displayValue: ''
    }
  },
  watch: {
    value: {
      handler() {
        this.initFromValue();
      },
      deep: true
    }
  },
  created() {
    this.getAreaData();
  },
  methods: {
    getAreaData() {
      // 这里假设jm.site.UTILS已全局可用，否则需import或通过props传入
      this.$axios.get(jm.site.UTILS + '/api/v1/address', {
        params: {}
      }).then(res => {
        if (res.success && res.data) {
          this.provinceList = res.data;
          this.initFromValue();
        } else {
          this.$toast && this.$toast(res.msg);
        }
      });
    },
    openDialog() {
      this.showDialog = true;
      this.initFromValue();
    },
    initFromValue() {
      // 回显外部传入的值
      this.selectedProvinceId = this.value.provice_id || '';
      if (this.selectedProvinceId) {
        const province = this.provinceList.find(p => String(p.id) === String(this.selectedProvinceId));
        this.cityList = province && province.childrens ? province.childrens : [];
      } else {
        this.cityList = [];
      }
      this.selectedCityId = this.value.city_id || '';
      if (this.selectedCityId) {
        const city = this.cityList.find(c => String(c.id) === String(this.selectedCityId));
        this.areaList2 = city && city.childrens ? city.childrens : [];
      } else {
        this.areaList2 = [];
      }
      this.selectedAreaId = this.value.area_id || '';
      // 展示名
      this.displayValue = this.value.provice_name && this.value.city_name && this.value.area_name
        ? `${this.value.provice_name} ${this.value.city_name} ${this.value.area_name}`
        : '';
    },
    onProvinceChange(e) {
      const provinceId = e.target.value;
      this.selectedProvinceId = provinceId;
      const province = this.provinceList.find(p => String(p.id) === String(provinceId));
      this.cityList = province && province.childrens ? province.childrens : [];
      this.selectedCityId = '';
      this.areaList2 = [];
      this.selectedAreaId = '';
    },
    onCityChange(e) {
      const cityId = e.target.value;
      this.selectedCityId = cityId;
      const city = this.cityList.find(c => String(c.id) === String(cityId));
      this.areaList2 = city && city.childrens ? city.childrens : [];
      this.selectedAreaId = '';
    },
    onAreaChange(e) {
      const areaId = e.target.value;
      this.selectedAreaId = areaId;
    },
    confirm() {
      const province = this.provinceList.find(p => String(p.id) === String(this.selectedProvinceId));
      const city = this.cityList.find(c => String(c.id) === String(this.selectedCityId));
      const area = this.areaList2.find(a => String(a.id) === String(this.selectedAreaId));
      if (!province || !city || !area) {
        this.$toast && this.$toast('请选择完整的省市区');
        return;
      }
      this.displayValue = `${province.sys_name} ${city.sys_name} ${area.sys_name}`;
      this.showDialog = false;
      this.$emit('input', {
        provice_id: province.id,
        city_id: city.id,
        area_id: area.id,
        provice_name: province.sys_name,
        city_name: city.sys_name,
        area_name: area.sys_name
      });
    },
    cancel() {
      this.showDialog = false;
    }
  }
}
</script>

<style scoped lang="scss">
.area-picker-input {
  width: 9.7rem;
  height: 1.4rem;
  border-radius: 0.4rem;
  background: #fff;
  border: 0.05rem solid #F5EC88;
  margin-bottom: 0.4rem;
  padding-left: 0.3rem;
  font-size: 0.6rem;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 0.7rem;
  outline: none;
  box-sizing: border-box;
  transition: border 0.2s;
  &::placeholder {
    color: #999999;
    font-weight: 400;
  }
  &:hover, &:focus {
    border-color: #F5EC88;
    background: #fff;
  }
}
.area-dialog-wrap {
  background: #fff;
  border-radius: 1.2rem 1.2rem 0 0;
  box-shadow: 0 0 24px 0 rgba(0,0,0,0.08);
  padding: 2rem 1.2rem 1.2rem 1.2rem;
  min-height: 16rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  &::before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 0.08rem;
    background: #f2f2f2;
    border-radius: 1.2rem 1.2rem 0 0;
  }
}
.area-dialog-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #222;
  text-align: center;
  margin-bottom: 1.5rem;
}
.area-dialog-selects {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 2rem;
}
.area-select {
  width: 100%;
  height: 2.2rem;
  border: 1px solid #e6e6e6;
  border-radius: 0.6rem;
  padding: 0 0.8rem;
  font-size: 1rem;
  background: #fafafa;
  outline: none;
  box-shadow: 0 2px 8px 0 rgba(0,0,0,0.03);
  transition: border 0.2s, box-shadow 0.2s;
  appearance: none;
  &:hover, &:focus {
    border-color: #e60020;
    box-shadow: 0 0 0 2px rgba(230,0,32,0.08);
    background: #fff;
  }
  option {
    font-weight: 400;
    color: #333;
    background: #fff;
    &:checked, &[selected] {
      font-weight: 600;
      color: #e60020;
    }
  }
}
.area-dialog-btns {
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 1rem;
}
.area-btn {
  flex: 1;
  height: 2.2rem;
  border: none;
  border-radius: 1.1rem;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s, box-shadow 0.2s, transform 0.1s;
  box-shadow: 0 2px 8px 0 rgba(230,0,32,0.04);
  &:active {
    transform: scale(0.97);
    box-shadow: 0 1px 4px 0 rgba(230,0,32,0.08);
  }
}
.area-btn.cancel {
  background: #f5f5f5;
  color: #888;
  &:hover {
    background: #ececec;
  }
}
.area-btn.confirm {
  background: linear-gradient(90deg, #e60020 0%, #ff4d6a 100%);
  color: #fff;
  &:hover {
    background: linear-gradient(90deg, #ff4d6a 0%, #e60020 100%);
  }
}
</style> 


// WEBPACK FOOTER //
// src/components/form/address/AreaPicker.vue